export default __webpack_public_path__ + "static/media/magic-story-1.0d55da6e.jpg";